module.exports = __webpack_public_path__ + "img/P32-en.d71cb953.png";